module.exports = function (product) {
    return {
        event: 'productClick',
        ecommerce: {
            click: {
                actionField: {
                    list: product.Source,
                },
                products: [
                    {
                        name: product.Name,
                        id: product.Stockcode,
                        price: product.Price,
                        variant: product.PackageSize,
                    },
                ],
            },
        },
    };
};



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/gtmmapper/productclick-analytics-mapper.js